import { Box } from '@mui/material';

import { CostCenter } from '~/data/costCenters';

import { useSxStyles } from './useStyles';

type Props = {
  costCenterId: number;
  percentage: number;
  hasCustomFields: boolean;
  costCenters: CostCenter[];
};

export const EmploymentDataCostCenter = ({
  costCenterId,
  percentage,
  hasCustomFields,
  costCenters,
}: Props) => {
  const sxStyles = useSxStyles();

  if (!costCenterId) {
    return <></>;
  }

  const costCenter = costCenters.find(
    (costCenter) => costCenter.fCostCenterId === costCenterId,
  );

  if (!costCenter) {
    return <></>;
  }

  const costCenterLabel = `${costCenter.fCostCenterCode} ${
    costCenter.fCostCenterName
  } ${percentage ? `(${percentage}%)` : ''}`;

  return (
    <Box component="span">
      <Box component="span">{costCenterLabel}</Box>
      {hasCustomFields ? (
        <Box component="span" sx={sxStyles.customFieldsMarker}>
          !
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};
